import { Col, Row, Image } from "antd";
import React from "react";
import MenuItemLayout from "./MenuItemLayout";
import banner from "../../../assets/images/intern_banner.png";
import heroMobile from "../../../assets/images/intern-mob.png";
import organigram from "../../../assets/images/organigram.jpg";
const OrganizationalStructure = () => {
  return (
    <MenuItemLayout
      mobileImage={heroMobile}
      title="الرئيسية"
      subTitle="الهيكل التنظيمي"
      urlImage={banner}
      className="takaful--our-story takaful--organigram"
    >
      <Row dir="rtl" justify="center">
        <Col span={22}>
          <Image.PreviewGroup>
            <Image
              className="takaful--organigram-img"
              src={organigram}
              alt="Organizational Structure"
              preview={{
                visible: true,
                mask: null, 
              }}
            />
          </Image.PreviewGroup>
        </Col>
      </Row>
    </MenuItemLayout>
  );
};

export default OrganizationalStructure;
